import { useEffect, useState } from "react";
import { LuFileEdit } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import dateFormat from "../../../../functions/dateFormat";


export default function TableDatalis ({
    head, 
    data, 
    name, 
    edit, 
    myDelete }) {
    const [body, setBody] = useState([]);

    useEffect(() => {
        let tr = [];
        
        Object.keys(data).length > 0 && Object.keys(data).map((value, key) => {
            let td = [];
            switch (name){
                case 'passport':
                case 'visa':
                    let {land, number, firstName, lastName, expiry, issue} = data[value];
                    const diffrent = (new Date(expiry) - new Date()) / (1000 * 60 * 60 * 24);
                    const color = 365 > diffrent ? 182.5 > diffrent ? 'redColor' : 'orangeColor': 'normalColor';
                    td.push(<td key={0}> {key + 1} </td>, <td key={1}> {land} </td>, <td key={2}> {number} </td>);
                    td.push(<td key={3}> {name === 'passport' ? `${firstName} ${lastName}` : dateFormat(issue) } </td>);
                    td.push(<td className={color} key={4}> {dateFormat(expiry)} </td>);
                    td.push(<td key={5}> <LuFileEdit className="icon-1" onClick={() => edit(value)} />  </td>)
                    td.push(<td key={6}> <AiOutlineDelete className="icon-1" style={{color:"red"}} onClick={() => myDelete(value)} /> </td>);
                    break;
                case 'contact':
                    td.push(<td key={0}> {key + 1} </td>, <td key={1}> {data[value]['type']} </td>, <td key={2}> {data[value]['data']} </td>);
                    td.push(<td key={3}> <AiOutlineDelete style={{color: "red"}} className="icon-1" onClick={() => myDelete(value)} />  </td>);
                    break;
                case 'ff':
                    const {compny, code, number:numberFf, remark} = data[value];
                    td.push(<td key={1}> {key + 1} </td>, <td key={2}> {compny} </td>, <td key={3}> {code} </td>, <td key={4}> {numberFf} </td>, <td key={5}> {remark} </td>);
                    td.push(<td key={6}> <LuFileEdit className="icon-1" onClick={() => edit(value)} /> </td>);
                    td.push(<td key={7}> <AiOutlineDelete className="icon-1" style={{color:"red"}} onClick={() => myDelete(value)} /> </td>);
                    break;
                case 'note':
                    td.push(<td key={1}> {key + 1} </td>, <td key={2}> {data[value]['dataNote']} </td>);
                    td.push(<td key={3}> <LuFileEdit className="icon-1" onClick={() => edit(value)} /> </td>);
                    td.push(<td key={4}> <AiOutlineDelete className="icon-1" style={{color:"red"}} onClick={() => myDelete(value)} /> </td>);
                    break;
                case 'credit':
                    td.push(<td key={1}> {key + 1} </td>, <td key={2} style={{'direction': 'ltr'}}> {data[value]['number']} </td>, <td key={3}> {data[value]['date']} </td>,
                            <td key={4}> {data[value]['cvv']} </td>, <td key={5}> {data[value]['id']} </td>);
                    td.push(<td key={6}> <AiOutlineDelete className="icon-1" style={{color:"red"}} onClick={() => myDelete(value)} /> </td>);
                    break;
            }
            tr.push(<tr key={key}>{td}</tr>)
        })
        setBody(tr);
    }, [data])

    return ( body.length > 0 &&
        <div className="scrool-table">
            <table className="TableDatalis">
                <thead>
                    <tr>{head.map((value, key) => <td key={key}> {value} </td>)}</tr>
                </thead>

                <tbody>
                    {body}
                </tbody>

            </table>
        </div>
    )
}